import { axisVariants } from './axisVariants'
import { pieVariants } from './pieVariants'
import { treemapVariants } from './treemapVariants'
import { funnelVariants } from './funnelVariants'
import { ringVariants } from './ringVariants'

const chartVariantsByLayout = {
  axis: axisVariants,
  pie: pieVariants,
  treemap: treemapVariants,
  funnel: funnelVariants,
  ring: ringVariants
}

export function getChartVariantsForLayout (layout) {
  return chartVariantsByLayout[layout] ?? {}
}

export function getChartVariantOptions (layout) {
  const variants = getChartVariantsForLayout(layout)
  return Object.values(variants).map(v => ({
    value: v.code,
    label: v.displayName,
    description: v.description
  }))
}

export function resolveChartVariant (layout, variantCode) {
  const variants = getChartVariantsForLayout(layout)
  return variants[variantCode] ?? variants.default ?? null
}

export function getChartVariantParameters (layout, variantCode) {
  const variant = resolveChartVariant(layout, variantCode)
  return variant?.parameters ?? []
}
